import { NAME } from './constants';

export const SET_LOCALE = `${NAME}/setLocale`;
export const SET_ARCHIVE_ID = `${NAME}/setArchiveId`;
export const SET_PROJECT_ID = `${NAME}/setProjectId`;
export const SET_AVAILABLE_VIEW_MODES = `${NAME}/setAvailableViewModes`;
export const SET_VIEW_MODE = `${NAME}/setViewMode`;
export const CLEAR_VIEW_MODES = `${NAME}/clearViewModes`;
export const CHANGE_TO_EDIT_VIEW = `${NAME}/changeToEditView`;
export const CHANGE_TO_TRANSLATIONS_VIEW = `${NAME}/changeToTranslationsView`;
export const CHANGE_TO_INTERVIEW_EDIT_VIEW = `${NAME}/changeToInterviewEditView`;
export const RECEIVE_RESULT = `${NAME}/receiveResult`;
export const UPDATE_SELECTED_ARCHIVE_IDS = `${NAME}/updateSelectedArchiveIds`;
export const SET_SELECTED_ARCHIVE_IDS = `${NAME}/setSelectedArchiveIds`;
export const UPDATE_SELECTED_REGISTRY_ENTRY_IDS = `${NAME}/updateSelectedRegistryEntryIds`;
export const MERGE_TRANSLATIONS = `${NAME}/mergeTranslations`;
export const REQUEST_TRANSLATIONS = `${NAME}/requestTranslations`;
